import { Bike, Truck } from "lucide-react";

export const VEHICLES = { bicycle: { label: "Bicycle", icon: Bike, tone: "bg-emerald-50 text-emerald-700" }, scooter: { label: "Scooter/Bike", icon: Bike, tone: "bg-amber-50 text-amber-700" }, van: { label: "Van", icon: Truck, tone: "bg-sky-50 text-sky-700" } };

export const VehicleBadge = ({ vehicle, testid }) => {
  const v = VEHICLES[vehicle];
  if (!v) return null;
  const Icon = v.icon;
  return <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium ${v.tone}`} data-testid={testid}><Icon className="h-3 w-3" />{v.label}</span>;
};
